const ConfigType = Object.freeze({
    BACKGROUND_IMAGE: 'BackgroundImage',
    DARK_BACKGROUND_IMAGE: 'DarkBackgroundImage',
    TELEGRAM_GROUP: 'TelegramGroup',
    WHATSAPP_GROUP: 'WhatsappGroup'
});

export { ConfigType };